import javaService from "../../utils/request"

 // 分类数据
 export function classificationEntrance(data){
  return javaService({
    url: '/classificationFront/classificationEntrance',
    method: 'GET',
    params: data
  })
 }
